import { http, toArray } from "../../lib/http";

/* ------------------------------ NEGOCIOS ------------------------------ */
export const businesses = {
  list: (params) =>
    http.get("/admin/businesses", { params }).then((r) => r.data),
  show: (id) => http.get(`/admin/businesses/${id}`).then((r) => r.data),
  create: (body) => http.post("/admin/businesses", body).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/businesses/${id}`, body).then((r) => r.data),
  /** Catálogo ligero para poblar selectores. */
  options: () =>
    http
      .get("/admin/businesses", { params: { per_page: 200, light: 1 } })
      .then((r) => toArray(r.data)),

  /* --- Medios en Cloudflare R2 ---
     La subida va por el backend: las llaves del bucket dan permiso de
     escritura sobre todo y no pueden llegar al navegador. */
  media: {
    list: (id) => http.get(`/admin/businesses/${id}/media`).then((r) => r.data),
    upload: (id, file, tipo = "galeria", onProgress) => {
      const datos = new FormData();
      datos.append("file", file);
      datos.append("tipo", tipo);
      return http
        .post(`/admin/businesses/${id}/media`, datos, {
          onUploadProgress: (e) =>
            onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
          timeout: 120000, // una foto por red lenta tarda más que una consulta
        })
        .then((r) => r.data);
    },
    remove: (id, key) =>
      http
        .delete(`/admin/businesses/${id}/media`, { data: { key } })
        .then((r) => r.data),
  },
};


/* ------------------------------ PRODUCTOS ----------------------------- */
export const products = {
  list: (params) => http.get("/admin/products", { params }).then((r) => r.data),
  /**
   * Desglose por categoría, agregado en la base.
   *
   * La pantalla lo necesita para su selector y antes lo derivaba recorriendo
   * el catálogo entero en el navegador — con lo cual pedía las 755 ofertas
   * además de la página, y la paginación no ahorraba nada.
   */
  categorias: () =>
    http.get("/admin/products/categorias").then((r) => toArray(r.data)),
  create: (body) => http.post("/admin/products", body).then((r) => r.data),
  show: (id) => http.get(`/admin/products/${id}`).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/products/${id}`, body).then((r) => r.data),
};


/* ------------------------------ CATEGORÍAS ---------------------------- */
export const categories = {
  /** `scope`: product | business */
  list: (scope) =>
    http.get("/admin/categories", { params: { scope } }).then((r) => r.data),
  create: (scope, body) =>
    http.post("/admin/categories", { scope, ...body }).then((r) => r.data),
  update: (scope, id, body) =>
    http.put("/admin/categories", { scope, id, ...body }).then((r) => r.data),
  remove: (scope, id) =>
    http
      .delete("/admin/categories", { data: { scope, id } })
      .then((r) => r.data),
};


/* -------------------------- CONJUNTOS RESIDENCIALES ------------------- */
export const complexes = {
  list: (params) =>
    http.get("/admin/complexes", { params }).then((r) => r.data),
  create: (body) => http.post("/admin/complexes", body).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/complexes/${id}`, body).then((r) => r.data),
  remove: (id) => http.delete(`/admin/complexes/${id}`).then((r) => r.data),

  /*
   * EL PERSONAL DEL CONJUNTO.
   *
   * Un conjunto sin administrador no le sirve a nadie: es una ficha en una
   * tabla. Hasta ahora darle uno solo se podía por consola
   * (`php artisan conjunto:dueno`), y quien crea el conjunto desde acá no
   * tiene acceso al servidor.
   */
  staff: (id) => http.get(`/admin/complexes/${id}/staff`).then((r) => r.data),
  assignOwner: (id, body) =>
    http.post(`/admin/complexes/${id}/owner`, body).then((r) => r.data),
};


/* ----------------------------- PROPIETARIOS --------------------------- */
export const owners = {
  list: (params) => http.get("/admin/owners", { params }).then((r) => r.data),
  /** Tipos de documento y negocios disponibles para la ficha. */
  options: () => http.get("/admin/owners/options").then((r) => r.data),
  create: (body) => http.post("/admin/owners", body).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/owners/${id}`, body).then((r) => r.data),
};


/* --------------------------- UBICACIONES ------------------------------ */
export const locations = {
  /** Departamentos con sus municipios, en una sola respuesta. */
  list: () => http.get("/admin/locations").then((r) => r.data),
};


export const media = {
  /** Estado del almacenamiento R2, para la pantalla de Ajustes. */
  storage: () => http.get("/admin/storage").then((r) => r.data),
  list: (entidad, id) =>
    http.get(`/admin/media/${entidad}/${id}`).then((r) => r.data),
  upload: (entidad, id, file, tipo = "galeria", onProgress) => {
    const datos = new FormData();
    datos.append("file", file);
    datos.append("tipo", tipo);
    return http
      .post(`/admin/media/${entidad}/${id}`, datos, {
        onUploadProgress: (e) =>
          onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
        timeout: 120000, // una foto por red lenta tarda más que una consulta
      })
      .then((r) => r.data);
  },
  /** El borrado va por id de `media_files`, no por la clave del objeto:
      el servidor comprueba la pertenencia contra la base. */
  remove: (entidad, id, mediaId) =>
    http
      .delete(`/admin/media/${entidad}/${id}`, { data: { id: mediaId } })
      .then((r) => r.data),
  setPrimary: (entidad, id, mediaId) =>
    http
      .put(`/admin/media/${entidad}/${id}/principal`, { id: mediaId })
      .then((r) => r.data),
};
